import React from 'react';
export function UrgencyBanner() {
  return <div className="bg-swiss-card-bg border-b border-gray-200 py-2 px-4 text-center" data-id="element-207">
      <p className="text-xs sm:text-sm font-medium text-swiss-charcoal" data-id="element-208">
        🇨🇭 100% Lehrplan 21 · Entwickelt für Schweizer Lehrpersonen
      </p>
    </div>;
}